import React from 'react';
import JiraImportModal from '../projects/Modals/JiraImportModal';
import { useEffect, useState } from 'react';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
import JiraConfigModal from './JiraConfigModal';
import BitbucketSettingsModal from './BitbucketSettingsModal';
import WorkXiqSettingsModal from './WorkXiqSettingsModal';
// import { toast } from 'react-toastify'; // Commented out - using react-toast now
import { toast } from 'react-toast';

const IntegrationSettings = () => {
  const [isJiraConfigModalOpen, setIsJiraConfigModalOpen] = useState(false);
  const [isJiraImportModalOpen, setIsJiraImportModalOpen] = useState(false);
  const [isBitbucketModalOpen, setIsBitbucketModalOpen] = useState(false);
  const [isWorkXiqModalOpen, setIsWorkXiqModalOpen] = useState(false);
  const [jiraCredentials, setJiraCredentials] = useState(null);
  const [bitbucketCredentials, setBitbucketCredentials] = useState(null);
  const [workXiqCredentials, setWorkXiqCredentials] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingIntegration, setEditingIntegration] = useState(null);
  const [loadingStates, setLoadingStates] = useState({
    jira: false,
    bitbucket: false,
    github: false,
    slack: false,
    jenkins: false,
    gitlab: false,
    projectpulse: false
  });

  const [integrations, setIntegrations] = useState([
    {
      id: 'jira',
      name: 'Jira',
      description: 'Connect to Jira for issue tracking and test case management',
      status: 'disconnected',
      isConfigured: null,
      isConnected: false,
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0052CC">
          <path d="M11.571 11.513H0a5.218 5.218 0 0 0 5.232 5.215h2.13v2.057A5.215 5.215 0 0 0 12.575 24V12.518a1.005 1.005 0 0 0-1.005-1.005z" />
          <path d="M5.01 11.513H16.58a5.215 5.215 0 0 0-5.232-5.215H9.22V4.243A5.216 5.216 0 0 0 4.004 0v11.513a1.005 1.005 0 0 0 1.005 0z" fill="#2684FF" />
        </svg>
      ),
    },
    {
      id: 'projectpulse',
      name: 'WorkXiq',
      description: 'Connect to WorkXiq for team collaboration and insights',
      status: 'disconnected',
      isConfigured: null,
      isConnected: false,
      logo: (
        <img 
          src="/workxiq-logo.svg"
          alt="WorkXiq" 
          style={{ width: '24px', height: '24px', objectFit: 'contain' }}
        />
      ),
    },
    {
      id: 'bitbucket',
      name: 'Bitbucket',
      description: 'Connect to Bitbucket for repository and team management',
      status: 'disconnected',
      isConfigured: null,
      isConnected: false,
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0052CC">
          <path d="M1.626 2.255c-.467 0-.867.275-1.063.695L0 5.117v13.766l1.563 2.167c.196.42.596.696 1.063.696h20.748c.467 0 .867-.276 1.063-.696l1.563-2.167V5.117L23.437 2.95c-.196-.42-.596-.696-1.063-.696H1.626zM11.96 15.22l-3.69-5.343h7.38L11.96 15.22z" />
        </svg>
      ),
    },
    {
      id: 'github',
      name: 'GitHub',
      description: 'Connect to GitHub for code repository integration',
      status: 'disconnected',
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#181717">
          <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z" />
        </svg>
      )
    },
    {
      id: 'slack',
      name: 'Slack',
      description: 'Connect to Slack for notifications and team collaboration',
      status: 'disconnected',
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M23.955 13.587l-1.342-4.135-2.664-8.189a.455.455 0 0 0-.867 0L16.418 9.45H7.582L4.919 1.263a.455.455 0 0 0-.867 0L1.386 9.45.044 13.587a.924.924 0 0 0 .331 1.03L12 23.054l11.625-8.437a.92.92 0 0 0 .33-1.03" fill="#FC6D26" />
        </svg>
      )
    },
     {
      id: 'jenkins',
      name: 'Jenkins',
      description: 'Connect to Jenkins for CI/CD integration',
      status: 'disconnected',
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M4.738 7.917c-.64-.64-1.513-1.036-2.486-1.036-.973 0-1.846.396-2.486 1.036-.64.64-1.036 1.513-1.036 2.486 0 .973.396 1.846 1.036 2.486.64.64 1.513 1.036 2.486 1.036.973 0 1.846-.396 2.486-1.036.64-.64 1.036-1.513 1.036-2.486 0-.973-.396-1.846-1.036-2.486z" fill="#D33833" />
          <path d="M12.246 0c-1.36 0-2.59.55-3.48 1.44-.89.89-1.44 2.12-1.44 3.48 0 1.36.55 2.59 1.44 3.48.89.89 2.12 1.44 3.48 1.44 1.36 0 2.59-.55 3.48-1.44.89-.89 1.44-2.12 1.44-3.48 0-1.36-.55-2.59-1.44-3.48-.89-.89-2.12-1.44-3.48-1.44z" fill="#D33833" />
          <path d="M19.754 7.917c-.64-.64-1.513-1.036-2.486-1.036-.973 0-1.846.396-2.486 1.036-.64.64-1.036 1.513-1.036 2.486 0 .973.396 1.846 1.036 2.486.64.64 1.513 1.036 2.486 1.036.973 0 1.846-.396 2.486-1.036.64-.64 1.036-1.513 1.036-2.486 0-.973-.396-1.846-1.036-2.486z" fill="#D33833" />
          <path d="M12.246 15.833c-1.36 0-2.59.55-3.48 1.44-.89.89-1.44 2.12-1.44 3.48 0 1.36.55 2.59 1.44 3.48.89.89 2.12 1.44 3.48 1.44 1.36 0 2.59-.55 3.48-1.44.89-.89 1.44-2.12 1.44-3.48 0-1.36-.55-2.59-1.44-3.48-.89-.89-2.12-1.44-3.48-1.44z" fill="#D33833" />
        </svg>
      )
    },
    {
      id: 'gitlab',
      name: 'GitLab',
      description: 'Connect to GitLab for code repository integration',
      status: 'disconnected',
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M23.955 13.587l-1.342-4.135-2.664-8.189a.455.455 0 0 0-.867 0L16.418 9.45H7.582L4.919 1.263a.455.455 0 0 0-.867 0L1.386 9.45.044 13.587a.924.924 0 0 0 .331 1.03L12 23.054l11.625-8.437a.92.92 0 0 0 .33-1.03" fill="#FC6D26" />
        </svg>
      )
    }
  ]);

  useEffect(() => {
    const checkIntegrationsStatus = async () => {
      try {
        setLoadingStates(prev => ({ ...prev, jira: true, bitbucket: true, projectpulse: true }));
        const authDataString = localStorage.getItem('user');
        if (!authDataString) return;

        const { accessToken } = JSON.parse(authDataString);

        // const response = await axios.get(
        //   `${process.env.REACT_APP_BASE_URL}/users/check_integration_conn`,
        //   {
        //     headers: {
        //       token: accessToken,
        //       accept: 'application/json',
        //     },
        //   }
        // );
        const response = await axiosInstance.get(
          `/users/check_integration_conn`

        );

//         const response = {
//     "connections": {
//         "jira": {
//             "is_connected": null,
//             "domain": "https://datopic.atlassian.net",
//             "email": "atamta@datopic.com",
//             "message": "Jira credentials found"
//         },
//         "bitbucket": {
//             "is_connected": false,
//             "username": "Atul 12",
//             "message": "Bitbucket credentials found"
//         },
//         "project_pulse": {
//             "is_connected": false,
//             "username": null,
//             "message": "WorkXiq credentials not set"
//         }
//     },
//     "status_code": 200
// }

        // Handle Jira status
        const jiraData = response?.connections?.jira;
        if (jiraData) {
          setJiraCredentials({ domain: jiraData.domain, email: jiraData.email });
          setIntegrations((prev) =>
            prev.map((integration) => {
              if (integration.id === 'jira') {
                if (jiraData.message === "Jira credentials found") {
                  return {
                    ...integration,
                    isConfigured: true,
                    isConnected: jiraData.is_connected,
                    status: jiraData.is_connected ? 'connected' : 'disconnected',
                  };
                } else {
                  return {
                    ...integration,
                    isConfigured: false,
                    isConnected: false,
                    status: 'disconnected',
                  };
                }
              }
              return integration;
            })
          );
        }

        // Handle WorkXiq status
        const workXiqData = response?.connections?.project_pulse;
 if (workXiqData) {
  setWorkXiqCredentials({ username: workXiqData.username });

  setIntegrations((prev) =>
    prev.map((integration) => {
      if (integration.id === 'projectpulse') {
        const isConfigured =
          (workXiqData.message == 'WorkXiq credentials found' || workXiqData.message == 'Project Pulse credentials found');
          // console.log(isConfigured,"configured");
        return {
          ...integration,
          isConfigured,
          isConnected: workXiqData.is_connected,
          status: workXiqData.is_connected
            ? 'connected'
            : 'disconnected',
        };
      }
    
      return integration;
    })
  );
}

// console.log(integrations,"integration value");


        // Handle Bitbucket status
        const bitbucketData = response?.connections?.bitbucket;
        if (bitbucketData) {
          setBitbucketCredentials({ username: bitbucketData.username });
          setIntegrations((prev) =>
            prev.map((integration) => {
              if (integration.id === 'bitbucket') {
                        const isConfigured =
          bitbucketData.message == 'Bitbucket credentials found';   
                return {
                  ...integration,
                  isConfigured,
                  isConnected: bitbucketData.is_connected,
                  status: bitbucketData.is_connected ? 'connected' : 'disconnected',
                };
              }
              return integration;
            })
          );
        }
        
      } catch (err) {
        console.error('Failed to fetch integrations status:', err.message);
      } finally {
        setLoadingStates(prev => ({ ...prev, jira: false, bitbucket: false, projectpulse: false }));
      }
    };

    checkIntegrationsStatus();
  }, []);

  const handleJiraConnectSuccess = () => {
    setIntegrations(prevIntegrations =>
      prevIntegrations.map(integration =>
        integration.id === 'jira'
          ? {
            ...integration,
            isConfigured: true,
            isConnected: true,
            status: 'connected'
          }
          : integration
      )
    );
  };

  const handleBitbucketConnectSuccess = () => {
    setIntegrations(prevIntegrations =>
      prevIntegrations.map(integration =>
        integration.id === 'bitbucket'
          ? {
            ...integration,
            isConfigured: true,
            isConnected: true,
            status: 'connected'
          }
          : integration
      )
    );
    setIsBitbucketModalOpen(false);
  };

  const handleWorkXiqConnectSuccess = () => {
    setIntegrations(prevIntegrations =>
      prevIntegrations.map(integration =>
        integration.id === 'projectpulse'
          ? {
            ...integration,
            isConfigured: true,
            isConnected: true,
            status: 'connected'
          }
          : integration
      )
    );
    setIsWorkXiqModalOpen(false);
  };

  const connectWithExistingCredentials = async () => {
    try {
      setLoadingStates(prev => ({ ...prev, jira: true }));
      const authDataString = localStorage.getItem('user');
      if (!authDataString) return;
      const { accessToken } = JSON.parse(authDataString);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/jira_data/toggle_connection`,
        { is_connected: true },
        {
          headers: {
            token: accessToken,
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        }
      );

      if (response.data.is_connected) {
        handleJiraConnectSuccess();
        toast.success(response.data.message || 'Connected to JIRA successfully');
      } else {
        toast.error(response.data.message || 'Failed to connect to JIRA');
      }
    } catch (error) {
      console.error("Failed to connect to JIRA:", error.message);
      toast.error(error.response?.data?.message || 'Failed to connect to JIRA');
    } finally {
      setLoadingStates(prev => ({ ...prev, jira: false }));
    }
  };

  const handleToggleIntegration = async (id) => {
    setLoadingStates(prev => ({ ...prev, [id]: true }));

    if (id === "jira") {
      const jiraIntegration = integrations.find(i => i.id === 'jira');
      if (!jiraIntegration) return;

      const { isConfigured, isConnected } = jiraIntegration;

      if (!isConfigured) {
        setIsJiraConfigModalOpen(true);
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        return;
      }

      if (isConfigured && !isConnected) {
        if (jiraCredentials) {
          await connectWithExistingCredentials();
        } else {
          setIsJiraImportModalOpen(true);
        }
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        return;
      }

      try {
        const authDataString = localStorage.getItem('user');
        if (!authDataString) return;
        const { accessToken } = JSON.parse(authDataString);

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/jira_data/toggle_connection`,
          { is_connected: false },
          {
            headers: {
              token: accessToken,
              'Content-Type': 'application/json',
              accept: 'application/json',
            },
          }
        );

        setIntegrations(prev =>
          prev.map(integration =>
            integration.id === 'jira'
              ? {
                ...integration,
                isConnected: false,
                status: 'disconnected',
              }
              : integration
          )
        );
        toast.success('Disconnected from JIRA successfully', {
          position: 'top-right',
          duration: 3000,
        });
      } catch (error) {
        console.error("Failed to disconnect from JIRA:", error.message);
        toast.error('Failed to disconnect from JIRA', {
          position: 'top-right',
          duration: 3000,
        });
      } finally {
        setLoadingStates(prev => ({ ...prev, [id]: false }));
      }
    } else if (id === 'bitbucket') {
      let is_connect ;
      const bitbucketIntegration = integrations.find(i => i.id === 'bitbucket');
      if (!bitbucketIntegration) return;

      const { isConfigured, isConnected } = bitbucketIntegration;

      if (!isConfigured) {
        setEditingIntegration(null);
        setBitbucketCredentials(null);
        setIsEditMode(false);
        setIsBitbucketModalOpen(true);
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        return;
      }

      if (isConfigured && !isConnected) {
        setEditingIntegration(null);
        setBitbucketCredentials(null);
        setIsEditMode(false);
        is_connect = true;
        // setIsBitbucketModalOpen(true);
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        // return;
      }
      else {
        is_connect = false;
      }

      // Disconnect Bitbucket
      try {
        await axiosInstance.post('/toggle_bitbucket_connection', { is_connected: is_connect });
        setIntegrations(prev =>
          prev.map(integration =>
            integration.id === 'bitbucket'
              ? {
                ...integration,
                isConnected: is_connect,
                status: 'disconnected',
              }
              : integration
          )
        );
        // toast.success('Disconnected from Bitbucket successfully', {
        //   position: 'top-right',
        //   duration: 3000,
        // });
      } catch (error) {
        console.error("Failed to disconnect from Bitbucket:", error.message);
        toast.error('Failed to disconnect from Bitbucket', {
          position: 'top-right',
          duration: 3000,
        });
      } finally {
        setLoadingStates(prev => ({ ...prev, [id]: false }));
      }
    } else if (id === 'projectpulse') {
      let is_connect ;
      const projectPulseIntegration = integrations.find(i => i.id === 'projectpulse');
      if (!projectPulseIntegration) return;

      const { isConfigured, isConnected } = projectPulseIntegration;

      if (!isConfigured) {
        setWorkXiqCredentials(null);
        setIsEditMode(false);
        setIsWorkXiqModalOpen(true);
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        return;
      }

      if (isConfigured && !isConnected) {
        setWorkXiqCredentials(null);
        setIsEditMode(false);
        is_connect = true;
        // setIsWorkXiqModalOpen(true);
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        // return;
      }
      else {
        is_connect = false;
      }

      // Disconnect WorkXiq
      try {
        // API call commented out for now - uncomment when API is available
        await axiosInstance.post('/pulse/toggle_pulse_cred', { is_connected: is_connect });
        
        setIntegrations(prev =>
          prev.map(integration =>
            integration.id === 'projectpulse'
              ? {
                ...integration,
                isConnected: is_connect,
                status: 'disconnected',
              }
              : integration
          )
        );
        // toast.success('Disconnected from WorkXiq successfully', {
        //   position: 'top-right',
        //   duration: 3000,
        // });
      } catch (error) {
        console.error("Failed to disconnect from WorkXiq:", error.message);
        toast.error('Failed to disconnect from WorkXiq', {
          position: 'top-right',
          duration: 3000,
        });
      } finally {
        setLoadingStates(prev => ({ ...prev, [id]: false }));
      }
    } else {
      // Simulate API call for other integrations
      setTimeout(() => {
        setIntegrations(prev =>
          prev.map(integration =>
            integration.id === id
              ? {
                ...integration,
                status: integration.status === 'connected' ? 'disconnected' : 'connected'
              }
              : integration
          )
        );
        setLoadingStates(prev => ({ ...prev, [id]: false }));
      }, 1000);
    }
  };

  const handleEditIntegration = async (id) => {
    if (id === 'jira') {
      try {
        setLoadingStates(prev => ({ ...prev, jira: true }));
        
        const response = await axiosInstance.get('/jira_dataget_jira_credentials');
        
        if (response && response.credentials) {
          setJiraCredentials(response.credentials);
          setIsEditMode(true);
          setIsJiraConfigModalOpen(true);
        } else {
          toast.error('Failed to fetch Jira credentials', {
            position: 'top-right',
            duration: 3000,
          });
        }
      } catch (error) {
        console.error('Error fetching Jira credentials:', error);
        toast.error(error.response?.message || 'Failed to fetch Jira credentials', {
          position: 'top-right',
          duration: 3000,
        });
      } finally {
        setLoadingStates(prev => ({ ...prev, jira: false }));
      }
    } else if (id === 'bitbucket') {
      try {
        setLoadingStates(prev => ({ ...prev, bitbucket: true }));
        
        const response = await axiosInstance.get('/get_bitbucket_settings');
        
        if (response && response.data) {
          setBitbucketCredentials(response.data);
          setEditingIntegration('bitbucket');
          setIsEditMode(true);
          setIsBitbucketModalOpen(true);
        } else {
          toast.error('Failed to fetch Bitbucket credentials', {
            position: 'top-right',
            duration: 3000,
          });
        }
      } catch (error) {
        console.error('Error fetching Bitbucket credentials:', error);
        toast.error(error.response?.data?.message || 'Failed to fetch Bitbucket credentials', {
          position: 'top-right',
          duration: 3000,
        });
      } finally {
        setLoadingStates(prev => ({ ...prev, bitbucket: false }));
      }
    } else if (id === 'projectpulse') {
      try {
        setLoadingStates(prev => ({ ...prev, projectpulse: true }));
        
        // API call commented out for now - uncomment when API is available
        const response = await axiosInstance.get('/pulse/get_project_pulse_cred');
        
        // Temporary mock response
        // const mockResponse = {
        //   data: {
        //     username: 'aaggarwal-datopic',
        //     app_token: 'ATBBz4Et6YVLBxTGz65sd6gy8vye3C67D4A8'
        //   }
        // };
        
        if (response) {
          setWorkXiqCredentials(response);
          setIsEditMode(true);
          setIsWorkXiqModalOpen(true);
        } else {
          toast.error('Failed to fetch WorkXiq credentials', {
            position: 'top-right',
            duration: 3000,
          });
        }
      } catch (error) {
        console.error('Error fetching WorkXiq credentials:', error);
        toast.error(error.response?.data?.message || 'Failed to fetch WorkXiq credentials', {
          position: 'top-right',
          duration: 3000,
        });
      } finally {
        setLoadingStates(prev => ({ ...prev, projectpulse: false }));
      }
    }
  };

  return (
    <>
      <div className="settings-section">
        <div className="settings-section-intro">
          <h2 className="settings-section-title">Integrations</h2>
          <p className="settings-subtitle">Connect Jira, CI/CD and other tools.</p>
        </div>
        <div className="settings-integrations-status-row">
          <span className="settings-integrations-status-row__label">Status</span>
        </div>

        {integrations.map(integration => {
          const isComingSoon = ['github', 'slack', 'jenkins', 'gitlab'].includes(integration.id);

          return (
            <div key={integration.id} className="integration-card">
              <div className="integration-logo">
                {integration.logo}
              </div>
              <div className="integration-info">
                <div className="integration-name">
                  {integration.name}
                  {isComingSoon && <span style={{ color: 'red', fontWeight: 'bold', marginLeft: '0.5rem', cursor: 'help' }} title="Coming Soon">*</span>}
                </div>
                <div className="integration-description">{integration.description}</div>
              </div>

              <div className="integration-status-and-actions">
                {loadingStates[integration.id] ? (
                  <div className="card-stat">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <>
                    {(integration.id === 'jira' || integration.id === 'bitbucket' || integration.id === 'projectpulse') && !integration.isConfigured ? (
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => handleToggleIntegration(integration.id)}
                      >
                        Configure
                      </button>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {integration.isConnected ? (
                          <>
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={() => handleToggleIntegration(integration.id)}
                              disabled={isComingSoon}
                            >
                              Disconnect
                            </button>
                            <span className="status-badge connected">
                              <span className="status-dot connected"></span> Connected
                            </span>
                          </>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => handleToggleIntegration(integration.id)}
                              disabled={isComingSoon}
                            >
                              Connect
                            </button>
                            {integration.isConfigured && (
                              <button
                                type="button"
                                className="btn btn-outline"
                                onClick={() => handleEditIntegration(integration.id)}
                                style={{ marginLeft: '8px' }}
                                title="Edit Configuration"
                                disabled={isComingSoon}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                </svg>
                              </button>
                            )}
                            <span className="status-badge disconnected">
                              <span className="status-dot disconnected"></span> Disconnected
                            </span>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}

        <div className="settings-card" style={{ marginTop: '2rem' }}>
          <h3 className="settings-card-title">
            API Access
            <span style={{ color: 'red', fontWeight: 'bold', marginLeft: '0.5rem', cursor: 'help' }} title="Coming Soon">*</span>
          </h3>
          <p className="settings-card-description">
            Generate API keys to access Robitest Web programmatically.
          </p>
          <div className="form-group">
            <label className="form-label">API Key</label>
            <div style={{ display: 'flex' }}>
              <input
                type="text"
                className="form-input"
                value="••••••••••••••••••••••••••••••"
                readOnly
                disabled
                style={{ flex: 1, marginRight: '0.5rem' }}
              />
              <button type="button" className="btn btn-outline" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copy
              </button>
            </div>
            <div className="form-hint">Last generated on July 1, 2025</div>
          </div>
          <button type="button" className="btn btn-outline" disabled>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
            </svg>
            Generate New API Key
          </button>
        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-outline">Cancel</button>
          <button type="submit" className="btn btn-primary">Save Changes</button>
        </div>

        <JiraConfigModal
          isOpen={isJiraConfigModalOpen}
          onClose={() => {
            setIsJiraConfigModalOpen(false);
            setIsEditMode(false);
            setJiraCredentials(null);
          }}
          onConnectSuccess={handleJiraConnectSuccess}
          isEditMode={isEditMode}
          initialCredentials={jiraCredentials}
        />

        <JiraImportModal
          isOpen={isJiraImportModalOpen}
          onClose={() => setIsJiraImportModalOpen(false)}
          onImport={handleJiraConnectSuccess}
        />

        <BitbucketSettingsModal
          isOpen={isBitbucketModalOpen}
          onClose={() => {
            setIsBitbucketModalOpen(false);
            setIsEditMode(false);
            setEditingIntegration(null);
            setBitbucketCredentials(null);
          }}
          onConnectSuccess={handleBitbucketConnectSuccess}
          isEditMode={isEditMode}
          initialCredentials={bitbucketCredentials}
        />

        <WorkXiqSettingsModal
          isOpen={isWorkXiqModalOpen}
          onClose={() => {
            setIsWorkXiqModalOpen(false);
            setIsEditMode(false);
            setWorkXiqCredentials(null);
          }}
          onConnectSuccess={handleWorkXiqConnectSuccess}
          isEditMode={isEditMode}
          initialCredentials={workXiqCredentials}
        />
      </div>
    </>
  );
};

export default IntegrationSettings;